import React from 'react';
import { useIsComerciales } from 'src/feature-app/hooks';
import { SelectDpsDomain } from './SelectDpsDomain';
import { GeneralInputWidthWrapper } from './styleComponents';
import { store } from 'src/feature-app';
import { OneFormState } from 'src/types';

export const Trato = () => {
    const isComerciales = useIsComerciales();
	const dpsToken = isComerciales ? 'LCV_DDB_FRM_LEM_REC_LEM' : 'VW_DDB_FRM_LEM_REC_LEM';
	const { formInfo }: OneFormState = store.getState();

    return (
		<GeneralInputWidthWrapper noPaddingTop notALayer={formInfo.notALayer}  className="trato-input-wrapper">
			<SelectDpsDomain name="trato" label="Trato" token={dpsToken} domain="Treatment" nodeValue="VALUE" nodeText="VALUE" selected="Sr." noPaddingTop required />
		</GeneralInputWidthWrapper> 
    );
};
